export default "__VITE_ASSET__Dg28j6j$__"